/** @jsx h */

import { h } from 'preact'; // eslint-disable-line
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CSSTransitionGroup from 'preact-css-transition-group';

import BtnClose from '../BtnClose';
import BtnMinimize from '../BtnMinimize';
import ButtonResumeTs from '../ButtonResumeTs';

import aniIconBotWhite from '../../images/waiting-white.gif';

import styles from './index.scss';

import { BTS_EXPANDED, BTS_TROUBLESHOOTING, BTS_LIVE_AGENT_CHAT } from '../../consts';

const JoButtonGreen = ({
    buttonState,
    isRunningChat,
    isMobile,
    handleClick,
    handleMouseEnter,
    handleMouseLeave,
    handleCloseFromChatState,
    autoExpand,
    handleCloseClick,
    isBannerShow,
}) => {
    const isChatActive = buttonState === BTS_TROUBLESHOOTING || buttonState === BTS_LIVE_AGENT_CHAT;

    const buttonWrapperClasses = classNames({
        [styles.joButtonWrapper]: true,
        [styles.joButtonExpanded]: buttonState === BTS_EXPANDED || isChatActive,
        [styles.shift]: isBannerShow,
    });
    const chatButtonClasses = classNames({
        [styles.joButton]: true,
        [styles.joButtonInChatState]: isRunningChat,
    });
    const helpPanelClasses = classNames({
        [styles.needHelpPanel]: true,
        [styles.expanded]: buttonState === BTS_EXPANDED,
    });

    const resumeTsPanelClasses = classNames({
        [styles.resumeTroubleshootingPanel]: true,
        [styles.expanded]: buttonState === BTS_TROUBLESHOOTING,
    });

    const resumeTsPanelClickHandle = isMobile ? handleClick : () => {};

    const mouseHandlers = isMobile
        ? {}
        : {
              onMouseEnter: handleMouseEnter,
              onMouseLeave: handleMouseLeave,
          };

    const btnMsg = `${isChatActive ? 'Resume' : 'Start'} troubleshooting`;

    return (
        <div {...mouseHandlers} onClick={handleClick} className={buttonWrapperClasses}>
            <button className={chatButtonClasses} aria-label="">
                <img className={styles.botIcon} src={aniIconBotWhite} />
            </button>

            <CSSTransitionGroup component="div" transitionName="panel-anim">
                {buttonState === BTS_EXPANDED || isChatActive ? (
                    <div className={styles.contentButton}>
                        {(!isMobile || !isChatActive) && (
                            <div className={helpPanelClasses}>
                                <div className={styles.needHelpPanelInnerWrap}>
                                    <span>
                                        Need help with your{' '}
                                        <strong className={styles.productName}>Back-UPS</strong>?
                                    </span>

                                    {autoExpand && (
                                        <BtnMinimize white={true} onClick={handleCloseClick} />
                                    )}

                                    {isChatActive && (
                                        <BtnClose white={true} onClick={handleCloseFromChatState} />
                                    )}
                                </div>
                            </div>
                        )}

                        <div onClick={resumeTsPanelClickHandle} className={resumeTsPanelClasses}>
                            <div className={styles.resumeTroubleshootingPanelInnerWrap}>
                                {isMobile ? (
                                    isChatActive && <span>{btnMsg}</span>
                                ) : (
                                    <ButtonResumeTs
                                        className={styles.buttonResumTs}
                                        onClick={handleClick}
                                    >
                                        {btnMsg}
                                    </ButtonResumeTs>
                                )}

                                {isChatActive && isMobile && (
                                    <BtnClose white={true} onClick={handleCloseFromChatState} />
                                )}
                            </div>
                        </div>
                    </div>
                ) : null}
            </CSSTransitionGroup>
        </div>
    );
};

JoButtonGreen.propTypes = {
    buttonState: PropTypes.string,
    isRunningChat: PropTypes.bool,
    isMobile: PropTypes.bool,
    handleClick: PropTypes.func,
    handleMouseEnter: PropTypes.func,
    handleMouseLeave: PropTypes.func,
    handleCloseFromChatState: PropTypes.func,
    handleCloseClick: PropTypes.func,
    autoExpand: PropTypes.bool,
    isBannerShow: PropTypes.bool,
};

JoButtonGreen.defaultProps = {};

export default JoButtonGreen;
